<template>
	<Layout :navFixed="true" :transparent="true">
		<div class="container">
			<div class="row row-xs  mt-5 pb-5">
				<div class="col-12  mt-4 mb-5 justify-content-center">
					<div class="form-box ">
						<h3 class="mt-3">{{ $t("title") }}</h3>

						<FormulateForm name="form" v-model="form" class="p-2" @submit="save">
							<FormulateInput
								:label="$t('currentPassword')"
								type="password"
								name="currentPassword"
								:validation-name="$t('currentPassword')"
								validation="required"
							/>
							<FormulateInput
								:label="$t('password')"
								type="password"
								name="password"
								:validation-name="$t('password')"
								validation="required|min:6,length"
							/>
							<FormulateInput
								:label="$t('passwordConfirm')"
								type="password"
								name="password_confirm"
								validation="bail|required|confirm"
								:validation-name="$t('passwordConfirm')"
							/>

							<div class="d-flex justify-content-end mt-4">
								<div class="btn btn-primary" @click="$formulate.submit('form')">
									<span v-if="saving">{{ $t("saving") }} <span class="btn-loader" /> </span>
									<span v-else>{{ $t("button") }}</span>
								</div>
							</div>
						</FormulateForm>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import mixins from "@/mixins/mixins"

export default {
	name: "PasswordChange",
	mixins: [mixins],
	components: {
		Layout
	},
	data() {
		return {
			loading: false,
			saving: false,
			form: {
				currentPassword: null,
				password: null,
				password_confirm: null
			}
		}
	},
	async beforeMount() {
		this.loading = false
	},
	methods: {
		save() {
			if (!this.saving) {
				this.saving = true
				console.log(this.form)
				let dataInput = {
					currentPassword: this.form.currentPassword,
					password: this.form.password,
					passwordConfirm: this.form.password_confirm
				}
				this.update(dataInput)
			}
		},

		update(dataInput) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: UserPasswordUpdateInput!) {
							userPasswordUpdate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data: dataInput
					}
				})
				.then(() => {
					this.$toast.success("Contraseña actualizada correctamente")
					this.saving = false
					this.$router.go(-1)
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		}
	},
	i18n: {
		messages: {
			es: {
				title: "Cambiar contraseña",
				currentPassword: "Contraseña actual",
				password: "Contraseña nueva",
				passwordConfirm: "Confirmar contraseña",
				button: "Cambiar contraseña",
				saving: "Guardando..."
			},
			en: {
				title: "Change password",
				currentPassword: "Current password",
				password: "New password",
				passwordConfirm: "Confirm password",
				button: "Change password",
				saving: "Saving..."
			},
			pt: {
				title: "Alterar senha",
				currentPassword: "Senha atual",
				password: "Nova senha",
				passwordConfirm: "Confirmar senha",
				button: "Alterar senha",
				saving: "Salvando..."
			}
		}
	}
}
</script>

<style scoped>
.row {
	margin: auto;
	max-width: 360px;
}
</style>
